var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-info"},[_c('h1',{staticClass:"section-info__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"section-info__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.linkUrl)?_c('BaseLink',{attrs:{"to":_vm.linkUrl},domProps:{"innerHTML":_vm._s(_vm.linkLabel)}}):_vm._e()],1),_vm._v(" "),_vm._t("button")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1d3e33","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionInfo.vue
// module id = 593
// module chunks = 0